// apis
import { test } from '../../base/env';
import * as accounts from './real_api/accounts';
import * as configs from './real_api/configs';
import * as content from './real_api/content';
import * as locations from './real_api/locations';
import * as messaging from './real_api/messaging';
import * as orders from './real_api/orders';
import * as popup from './real_api/popup';
import * as products from './real_api/products';
import * as sellers from './real_api/sellers';
import * as test_accounts from './test_api/accounts';
import * as test_configs from './test_api/configs';
import * as test_content from './test_api/content';
import * as test_locations from './test_api/locations';
import * as test_messaging from './test_api/messaging';
import * as test_orders from './test_api/orders';
import * as test_products from './test_api/products';
import * as test_sellers from './test_api/sellers';

const realAPI = {
  get: {
    layout: content.getLayoutSection,
    headerLayout: content.getLayoutHeader,
    slider: content.getSlider,
    categories: products.getCategoies,
    productSliders: sellers.getProductSliders,
    products: sellers.getProducts,
    locationProvince: locations.getLocationProvince,
    locationCities: locations.getLocationCities,
    search: sellers.getSearch,
    productFilters: sellers.getProductFilters,
    captcha: accounts.getCaptcha,
    provinces: locations.getProvinces,
    cities: locations.getCities,
    regions: locations.getRegions,
    userAddresses: accounts.getUserAddresses,
    productDeliveries: sellers.getProductDeliveries,
    userOrders: orders.getUserOrders,
    editProfile: accounts.editProfile,
    credits: accounts.getCredits,
    faq: content.getFaqs,
    config: configs.getConfig,
    checkOtpPage: accounts.checkOtpPage,
    creditSummery: accounts.getCreditSummery,
    popup: popup.getPopup
  },
  post: {
    tokenLogin: accounts.postTokenLogin,
    firebase: messaging.postFirebase,
    card: sellers.postCard,
    sendOtp: accounts.postSendOtp,
    checkOtp: accounts.postCheckOtp,
    productDeliveries: sellers.postProductDeliveries,
    orderSummary: orders.postOrderSummary,
    requiredFields: orders.postRequiredFields,
    payment: orders.payment,
    userAddresses: accounts.postUserAddresses,
    giftCreditCode: accounts.postGiftCreditCode,
    chargeWallet: orders.postChargeWallet
  },
  del: {
    userAddresses: accounts.deleteUserAddresses
  },
  put: {
    userAddresses: accounts.putUserAddresses,
    putEditProfile: accounts.putEditProfile
  }
};

const testAPI = {
  get: {
    slider: test_content.getSlider,
    categories: test_products.getCategoies,
    productSliders: test_sellers.getProductSliders,
    products: test_sellers.getProducts,
    locationProvince: test_locations.getLocationProvince,
    locationCities: test_locations.getLocationCities,
    search: test_sellers.getSearch,
    productFilters: test_sellers.getProductFilters,
    captcha: test_accounts.getCaptcha,
    provinces: test_locations.getProvinces,
    cities: test_locations.getCities,
    regions: test_locations.getRegions,
    userAddresses: test_accounts.getUserAddresses,
    productDeliveries: test_sellers.getProductDeliveries,
    userOrders: test_orders.getUserOrders,
    editProfile: test_accounts.editProfile,
    credits: test_accounts.getCredits,
    faq: test_content.getFaqs,
    config: test_configs.getConfig,
    checkOtpPage: test_accounts.checkOtpPage,
    creditSummery: test_accounts.getCreditSummery
  },
  post: {
    tokenLogin: test_accounts.postTokenLogin,
    firebase: test_messaging.postFirebase,
    card: test_sellers.postCard,
    sendOtp: test_accounts.postSendOtp,
    checkOtp: test_accounts.postCheckOtp,
    productDeliveries: test_sellers.postProductDeliveries,
    orderSummary: test_orders.postOrderSummary,
    requiredFields: test_orders.postRequiredFields,
    payment: test_orders.payment,
    userAddresses: test_accounts.postUserAddresses,
    giftCreditCode: test_accounts.postGiftCreditCode,
    chargeWallet: test_orders.postChargeWallet
  },
  del: {
    userAddresses: test_accounts.deleteUserAddresses
  },
  put: {
    userAddresses: test_accounts.putUserAddresses,
    putEditProfile: test_accounts.putEditProfile
  }
};

// eslint-disable-next-line import/no-mutable-exports
let API = realAPI;

if (test) {
  API = testAPI;
}

export { API };
